import { BrowserRouter, Routes, Route } from "react-router-dom";
import createStore from "./Store";
import { Provider } from "react-redux";
import CreateUnitForm from "./components/CreateUnit/create_unit_form";
import MyTulu from "./pages/MyTulu";
import PDF from "./pages/PDF";
// import { Printer } from "./components/Printer/printer";
import { Printer as PrinterDb } from "./components/PrinterDb/printer";
import Login from "./components/login";
import DbInterfacePage from "./components/DbInterface/dbInterfacePage";
import { ACCESS_MODES } from "./components/utils/apiTarget";
import GetApp from "./pages/get_app";
import CreateUnit from "./pages/create_unit";
import React from "react";
import CarpenterProvider from "./components/CarpenterView/CarpenterProvider";
const store = createStore();

// DB Interface: the read-only links talk to the public API; the read-write links talk to
// the VPN-only internal API (api-rw.*). All four require a fresh, per-tab Google sign-in.
function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <BrowserRouter>
          <Routes>
            <Route path="/carpenter/:id" element={<CarpenterProvider />} />
            <Route path="/create_unit_form" element={<CreateUnitForm />} />
            <Route path="/create_unit" element={<CreateUnit />} />
            <Route
              path="/dbInterface"
              element={
                <Login requireFreshSession>
                  <DbInterfacePage accessMode={ACCESS_MODES.readOnly} />
                </Login>
              }
            />
            <Route
              path="/dbInterfaceTest"
              element={
                <Login requireFreshSession>
                  <DbInterfacePage accessMode={ACCESS_MODES.readOnly} isDev />
                </Login>
              }
            />
            <Route
              path="/dbInterfaceWrite"
              element={
                <Login requireFreshSession>
                  <DbInterfacePage accessMode={ACCESS_MODES.readWrite} />
                </Login>
              }
            />
            <Route
              path="/dbInterfaceTestWrite"
              element={
                <Login requireFreshSession>
                  <DbInterfacePage accessMode={ACCESS_MODES.readWrite} isDev />
                </Login>
              }
            />
            <Route path="/myTulu/:id" element={<MyTulu />} />
            {process.env.NODE_ENV === "development" && (
              <Route path="/PDF/:id" element={<PDF />} />
            )}
            <Route path="/get_app" element={<GetApp />} />
            {/*<Route*/}
            {/*  path="/printer"*/}
            {/*  element={*/}
            {/*    <Login>*/}
            {/*      <Printer />*/}
            {/*    </Login>*/}
            {/*  }*/}
            {/*/>*/}
            <Route
              path="/printer"
              element={
                <Login>
                  <PrinterDb />
                </Login>
              }
            />
          </Routes>
        </BrowserRouter>
      </Provider>
    </div>
  );
}

export default App;
